import { Skeleton } from '@cannect/new-components/atoms'

export const SubscriptionListSkeleton = () => (
  <div className="flex w-full flex-col gap-4" aria-busy="true" aria-label="Carregando assinaturas">
    <Skeleton className="h-8 w-56" />
    {[0, 1].map((key) => (
      <Skeleton key={key} className="h-48 w-full rounded-xl" />
    ))}
  </div>
)
